module.exports = __webpack_public_path__ + "img/5.17b6b7e5.jpg";